import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon/Icon";
import { withVar } from "themes/helpers";

import { StyledSpan } from "./CloseButtonStyles";

interface IProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to?: string;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-unused-vars, react/display-name
const CloseButton = React.forwardRef<HTMLSpanElement, IProps>(({ to, children, ...rest }, ref) => (
  <StyledSpan ref={ref} hasChildren={!!children} {...rest}>
    <Icon name={IconsEnum.Close} fill={withVar(DesignToken.ContentBasicPrimary)} inline />
  </StyledSpan>
));

export default CloseButton;
